import { Menu } from 'antd'
import { array, bool, func, object, string, oneOfType } from 'prop-types'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import * as moment from 'moment'
import 'moment/locale/pt-br'
import './step.css'

import InfoView from './infoView'
import SignersTab from './signers'
import VersionView from './versionView'
import Workflow from './workflow'
import AddendumsView from './addendumView'
import DocumentsView from './DocumentsView'
import TerminationView from './TerminationView'
import Configs from './configs'
import LogsView from './logsView'

moment.locale('pt-br')

const Tabs = ({
	workflowContext,
	downloadDocument,
	signers,
	infos,
	sent,
	signed,
	handleEditSigners,
	handlesendForSigning,
	loadingSign,
	downloadButton,
	downloadVersionHandler,
	modelsConfig,
	companyConfig,
}) => {
	const [activeTab, setActiveTab] = useState(0)
	const loggedUser = useSelector(({ session }) => session)
	const isAdmin = loggedUser?.perfil === 'admin'

	const normalizedSigners = Array.isArray(signers)
		? { signers, message: '', responsible_group: [] }
		: {
				signers: signers.signers || [],
				message: signers.message || '',
				responsible_group: signers.responsible_group || [],
			}

	const tabContents = [
		<InfoView key="0-info-tab" infos={infos} />,
		<VersionView
			key="1-version-tab"
			infos={infos}
			downloadVersionHandler={downloadVersionHandler}
			downloadDocument={downloadDocument}
		/>,
		<Workflow key="2-workflow-tab" workflowContext={workflowContext} />,
		<SignersTab
			key="3-signers-tab"
			signingParties={normalizedSigners.signers}
			message={normalizedSigners.message}
			responsibleGroup={normalizedSigners.responsible_group}
			loadingSign={loadingSign}
			sent={sent}
			signed={signed}
			downloadButton={downloadButton}
			handleEditSigners={handleEditSigners}
			handlesendForSigning={handlesendForSigning}
		/>,
		<DocumentsView
			key="4-documents-tab"
			document_id={infos?.id}
			documents={infos?.variables?.DOCUMENTOS ?? []}
		/>,
		<AddendumsView
			key="5-addendum-tab"
			document_id={infos?.id}
			addendum={infos?.addendum ?? []}
		/>,
		<TerminationView
			key="6-termination-tab"
			document_id={infos?.id}
			termination={infos?.termination}
		/>,
		<Configs key="7-configs-tab" configs={infos.configs} />,
	]

	if (isAdmin) {
		tabContents.push(<LogsView key="8-logs-tab" document_id={infos?.id} />)
	}

	const menuOptions = () => {
		const options = [
			{ label: 'Info', key: '0-info-tab' },
			{ label: 'Versões', key: '1-version-tab' },
		]

		if (
			companyConfig?.period_configs &&
			companyConfig?.period_configs.length > 0
		) {
			options.push({ label: 'Configurações', key: '7-configs-tab' })
		}

		if (workflowContext) {
			options.push({ label: 'Workflow', key: '2-workflow-tab' })
		}
		if (normalizedSigners.signers?.length) {
			options.push({ label: 'Assinatura', key: '3-signers-tab' })
		}
		if (modelsConfig?.allowAddendums) {
			options.push({ label: 'Aditivos', key: '5-addendum-tab' })
		}
		if (modelsConfig?.hasTermination) {
			options.push({ label: 'Distrato', key: '6-termination-tab' })
		}
		options.push({ label: 'Documentos Anexados', key: '4-documents-tab' })
		if (isAdmin) {
			options.push({ label: 'Logs', key: '8-logs-tab' })
		}
		return options
	}

	return (
		<div
			id="tabs-container"
			style={{
				padding: '10px',
				height: '100%',
				width: '40%',
				background: '#fff',
				border: '1px solid #F0F0F0',
				display: 'flex',
				flexDirection: 'column',
				gap: '20px',
			}}>
			<Menu
				id="tabs-menu"
				onSelect={(e) => {
					setActiveTab(Number(String(e.key).split('-')[0]))
				}}
				selectedKeys={[`${activeTab}`]}
				mode="horizontal"
				style={{
					width: '100%',
					flex: '0 0 0',
				}}
				items={menuOptions()}
			/>

			<div
				id="tabs-content"
				style={{ flex: 1, overflowY: 'scroll', padding: '0 15px 0 15px' }}>
				{tabContents[activeTab]}
			</div>
		</div>
	)
}

Tabs.propTypes = {
	workflowContext: object,
	textType: string,
	downloadDocument: func,
	signers: oneOfType([object, string]),
	versions: array,
	infos: object,
	showAssignModal: func,
	handleVersion: func,
	sent: bool,
	signed: bool,
	loadingSign: bool,
	versionId: string,
	text: string,
	textUpdate: object,
	onClickUpdate: func,
	blockVersion: bool,
	versionLoading: bool,
	downloadButton: func,
	block: bool,
	signedWorkflow: bool,
	downloadVersionHandler: func,
	handleEditSigners: func.isRequired,
	handlesendForSigning: func.isRequired,
	modelsConfig: object,
}

export default Tabs
